/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import meta from './meta';

export default combineReducers({
	meta,
});
